var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { cloneElement } from "react";
import classNames from "classnames";
import { IconSizes } from "../Icons/PropTypes/IconSizes";
export var HighlightedIconType;
(function (HighlightedIconType) {
    HighlightedIconType["Default"] = "default";
    HighlightedIconType["Info"] = "info";
    HighlightedIconType["Success"] = "success";
    HighlightedIconType["Danger"] = "danger";
    HighlightedIconType["Warning"] = "warning";
})(HighlightedIconType || (HighlightedIconType = {}));
const HighlightedIcon = (_a) => {
    var { children, type = HighlightedIconType.Default, size = IconSizes.Default, className } = _a, props = __rest(_a, ["children", "type", "size", "className"]);
    return (React.createElement("div", Object.assign({ className: classNames("gerudo-highlighted-icon", `gerudo-highlighted-icon-${type}`, size, className) }, props), cloneElement(children, { size })));
};
export default HighlightedIcon;
//# sourceMappingURL=HighlightedIcon.js.map